import { useState } from "react";
import { toast } from "sonner";
import { FileClock, Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { CA, caErr } from "@/lib/clientAdmin";
import { usd } from "@/lib/clientBilling";
import { useSI } from "@/lib/sourcing";

// §81 Draft invoices auto-created on the 1st, waiting for approval.
export const DraftInvoices = ({ onOpen }) => {
  const r = useSI(`${CA}/invoices?status=draft`);
  const [busy, setBusy] = useState("");
  const items = r.data?.items || [];
  const send = async (x) => { setBusy(x.id); try { await api.post(`${CA}/${x.client_id}/invoices/${x.id}/send`, {}); toast.success(`Invoice sent to ${x.company}`); r.reload(); } catch (e) { toast.error(caErr(e)); } finally { setBusy(""); } };
  const all = async () => { for (const x of items) await send(x); };
  if (!items.length) return null;
  return (
    <div className="rounded-2xl border border-[#8224e3]/40 bg-[#8224e3]/5 p-4" data-testid="ca-drafts">
      <div className="flex flex-wrap items-center gap-3"><FileClock className="h-4 w-4 text-[#c79bff]" /><p className="flex-1 text-sm text-zinc-100" data-testid="ca-drafts-title">{items.length} draft invoice{items.length > 1 ? "s" : ""} ready to review</p>
        <Button size="sm" disabled={!!busy} onClick={all} className="h-8 bg-[#8224e3] text-white" data-testid="ca-drafts-send-all"><Send className="h-3.5 w-3.5" />Approve & send all</Button></div>
      <div className="mt-2 space-y-1">{items.map((x) => <div key={x.id} className="flex flex-wrap items-center gap-2 border-t border-[#1f1f23] py-1.5 text-xs" data-testid={`ca-draft-${x.id}`}>
        <button onClick={() => onOpen(x.client_id)} className="flex-1 text-left text-zinc-200 hover:underline">{x.company} <span className="text-zinc-500">· {x.month}</span></button>
        <span className="font-mono text-zinc-100">{usd(x.total)}</span>
        <Button size="sm" variant="outline" disabled={!!busy} onClick={() => send(x)} className="h-7 border-[#27272A] text-xs" data-testid={`ca-draft-${x.id}-send`}>{busy === x.id ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />}Send</Button></div>)}</div>
    </div>
  );
};
